import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useSelector, useStore } from 'react-redux';
import i18n from './i18n';
import { initializeTenantTranslations } from './tenantTranslations';

/* import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/dist/locale-data/en";
import "@formatjs/intl-relativetimeformat/dist/locale-data/de";
import "@formatjs/intl-relativetimeformat/dist/locale-data/es";
import "@formatjs/intl-relativetimeformat/dist/locale-data/fr";
import "@formatjs/intl-relativetimeformat/dist/locale-data/ja";
import "@formatjs/intl-relativetimeformat/dist/locale-data/zh"; */

function I18nProvider({ children }) {
  const locale = useSelector(({ i18n }) => i18n.lang);
  const organization = useSelector(({ 'system-setting': systemSetting }) => systemSetting?.organization);
  const store = useStore();

  useEffect(() => {
    i18n.changeLanguage(locale);
    // Cargar traducciones específicas del tenant cuando cambie el idioma O cuando se cargue la organización
    initializeTenantTranslations(store, locale);
  }, [locale, organization, store]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default I18nProvider;
